import { createAction } from '@reduxjs/toolkit';
export const APP_INIT_ACTION = 'APP_INIT' as const;

// eslint-disable-next-line
export const appInitAction = createAction<Record<any, any>, typeof APP_INIT_ACTION>(APP_INIT_ACTION);
